var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatSquare = function SvgChatSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.56,
    d: "M27.02 19.441a2.56 2.56 0 0 1-2.56 2.56H9.1l-5.12 5.12V6.641a2.56 2.56 0 0 1 2.56-2.56h17.92a2.56 2.56 0 0 1 2.56 2.56z"
  })));
};
export default SvgChatSquare;